import { defineComponent as _defineComponent } from 'vue'
import { useRootStore } from '@/store/pinia';
import { withDefaults, computed } from 'vue'




export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    value: { type: Boolean },
    header: null,
    variant: { default: 'md' },
    position: { default: 'center' },
    dismissableMask: { type: Boolean, default: true }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as { value: boolean, header: string, variant: 'md' | 'lg' | 'xl' | 'xxl', position: 'top' | 'center', dismissableMask: boolean };





const width = computed(() => {
    switch (props.variant) {
        case 'md':
            return '400px';
        case 'lg':
            return '700px';
        case 'xl':
            return '900px';
        case 'xxl':
            return '1200px';
        default:
            return '400px';
    }
})

function toggleModal(val: boolean) {
    emit("input", val);
}


return { __sfc: true,props, emit, width, toggleModal, useRootStore }
}

})